(function() {
    const modal = document.getElementById('serviceModal');
    if (!modal) return;
    const backdrop = modal.querySelector('.modal__backdrop');
    const closeBtn = modal.querySelector('.modal__close');
    const titleEl = document.getElementById('modalTitle');
    const descEl = document.getElementById('modalDesc');
    function openModal(title, desc) {
        if (titleEl) titleEl.textContent = title || "\u0423\u0441\u043B\u0443\u0433\u0430 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435";
        if (descEl) descEl.textContent = desc || "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435.";
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        modal.setAttribute('aria-modal', 'true');
        document.body.style.overflow = 'hidden';
    }
    function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('aria-modal', 'false');
        document.body.style.overflow = '';
    }
    closeBtn && closeBtn.addEventListener('click', closeModal);
    backdrop && backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    document.addEventListener('click', function(e) {
        const heart = e.target.closest('.service-card__heart');
        if (!heart) return;
        e.preventDefault();
        const card = heart.closest('.service-card');
        const title = card ? card.getAttribute('data-title') : '';
        const desc = card ? card.getAttribute('data-desc') : '';
        openModal(title ? title + " \u2014 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435" : null, desc);
    });
    window.openServiceModal = openModal;
    window.closeServiceModal = closeModal;
})();

//# sourceMappingURL=services.f131cabc.js.map
